export const subActivityList = "SUBACTIVITY_LIST";